import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Main from "./Components/Home/Main";
import AddBenefit from "./Components/Home/AddBenefit";
import Protected from "./Components/Protected/Protected";
import { useState, useEffect } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";
import {
  auth,
  db,
  onMessageListener,
  onForegroundMessage,
  getFirebaseToken
} from "./Components/Firebase/firebase";
import RegisterationFinal from "./Components/Registeration/RegisterationFinal";
import LoginFinal from "./Components/Login/LoginFinal";
import AddClubFinal from "./Components/Home/AddClub/AddClubFinal";
import JoinClub from "./Components/Home/JoinClub/JoinClub";
import ManageClubsFinal from "./Components/Home/ManageClubs/ManageClubsFinal";
import BackgroundDecorations from "./Components/Common/BackgroundDecorations";
import HomeFinal from "./Components/HomeFinal";
import ManageBenefitzFinal from "./Components/Home/ManageBenefitz/ManageBenefitzFinal";
import AddBenefitFinal from "./Components/Home/AddBenefit/AddBenefitFinal";
import DailyReportFinal from "./Components/Home/DailyReport/DailyReportFinal";
import BenefitExplained from "./Components/Home/BenefitsExplained/BenefitExplained";
import MonthlyReportFinal from "./Components/Home/MonthlyReport/MonthlyReportFinal";
import Catalog from "./Components/catalog/Catalog/Catalog";
import CommunityCatalog from "./Components/catalog/Community/CommunityCatalog/CommunityCatalog";

function App() {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });
  console.log(show, notification);

  // onMessageListener()
  //   .then((payload) => {
  //     setShow(true);
  //     setNotification({
  //       title: payload.notification.title,
  //       body: payload.notification.body,
  //     });
  //     console.log(payload);
  //   })
  //   .catch((err) => console.log("failed: ", err));
 
  let data = {};

  const getDataFromRegisteration = async (rdata) => {
    data = rdata;
    console.log(data);
  };

  const [benefitArrayFC, setBenefitArrayFC] = useState([]);
  const getDataFromClubOffer = (benefitArray) => {
    setBenefitArrayFC(benefitArray);
  };

  const getDataFromBrandInfo = (bdata) => {
    data.brandInfo = bdata;
    console.log(data);

    toast.dismiss();
    toast.loading("Registering User");
    createUserWithEmailAndPassword(
      auth,
      data.brandInfo.email,
      data.brandInfo.password
    )
      .then(async (response) => {
        try {
          const userdocRef = await setDoc(
            doc(db, "users", response.user.uid),
            data
          );
          console.log(userdocRef);
          toast.dismiss();
          toast.success("User Registeration Success.");
          return <Navigate to={"/Login"} />;
        } catch (e) {
          console.log(e);
          toast.dismiss();
          toast.error("User Registeration fail.");
        }
      })
      .catch((e) => {
        console.log(e);
        toast.dismiss();
        toast.error("User Registeration fail of user already exists.");
      });
  };

  useEffect(() => {
    console.log("Initialize the irebase Messaging");

    try{
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js", {
          scope: "/firebase-cloud-messaging-push-scope",
        })
        .then((registration) => {
          console.log("sw registered:", registration);
          try{
            getFirebaseToken();
          }catch(error){
            console.error("Error calling getFirebaseToken():", error);
          }
        })
        .catch((err) =>
          console.error("sw registration failed:", err)
        );
    }else {
      console.warn("Service Worker is not supported in this browser.");
    }

    Notification.requestPermission().then((permission) => {
      console.log("permission:", permission)
    })
    .catch((err) =>{
      console.error("Failed to get Notification permission:", err);
    })

    const unsubscribe = onMessageListener((payload) => {
      try{
      console.log("Foreground notification waS received:", payload);
      setShow(true);
      setNotification({
        title: payload.notification?.title || "No Title",
        body: payload.notification?.body || "No Body",
      });
      toast(
        <ToastifyNotification
          title={payload.notification.title}
          body={payload.notification.body}
        />
      );
      } catch (err) {
        console.error("Error handling incoming notification:", err);
      }
    });

    return () => {
      try{
        if (typeof unsubscribe === "function") {
          unsubscribe();
        }
      }catch(err){
        console.error("Error while unsubscribing from FCM listener:", err);
      }
    };
    } catch (error) {
    console.error("Unexpected error in Firebase useEffect block:", error);
    }
  }, []);

  const ToastifyNotification = ({ title, body }) => (
    <div className="push-notification">
      <h2 className="push-notification-title">{title}</h2>
      <p className="push-notification-text">{body}</p>
    </div>
  );

  return (
    <>
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<LoginFinal />} />
            <Route path="/Login" element={<LoginFinal />} />
            <Route path="reg" element={
              <RegisterationFinal
                getDataFromRegisteration={getDataFromRegisteration}
              />
            }
          />

          {/*<Route path="Deco" element={<BackgroundDecorations />} />*/}

          <Route path="CommunityCatalog">
            <Route path=":idClub" element={<CommunityCatalog />} />
          </Route>
          <Route path="Catalog">
             <Route path=":id" element={<Catalog />} />
          </Route>

          <Route path="/" element={<Protected />}>
            <Route path="home" element={<HomeFinal />}>
              <Route path="code" element={<Main />} />
              <Route path="dailyHistoryFinal" element={<DailyReportFinal />} />
              <Route path="monthlyHistoryFinal" element={<MonthlyReportFinal />} />
              <Route path="Add_Benefit_To_Client" element={<AddBenefit />} />
              <Route path="ManageClubs" element={<ManageClubsFinal />} />
              <Route path="ManageClubs">
                <Route path="AddClub" element={<AddClubFinal />} />
                <Route path="JoinClub" element={<JoinClub />} />
                <Route path=":id">
                  <Route path="benefitsList" element={<ManageBenefitzFinal />} />
                  <Route path="benefits-explained" element={<BenefitExplained />} />
                  <Route path="addFinal" element={<AddBenefitFinal />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Routes>
       <ToastContainer theme="dark" />
      </BrowserRouter>
    </>
  );
}

export default App;
